import Meet from '@/assets/meet.svg?react';
import Phone from '@/assets/phone.svg?react';
import Button from '@/components/ui/Button';
import { HELPFIND_PHONE, HELPFIND_PHONE_HH } from '@/consts';
import { Paper } from '@/features/v2/summaryForms/components/offer/Offers';

import { useLingui } from '@lingui/react';

const AcceptOfferCard = ({ isHouseHold }: { isHouseHold?: boolean }) => {
  const { i18n } = useLingui();

  return (
    <Paper className="col-span-2 mt-4 flex flex-col gap-y-[22px] lg:mt-0">
      <div className="flex items-center gap-2">
        <Meet className="size-[26px] text-primary" />
        <h3 className="h3 lg:h2">{i18n.t('Cieszymy się na współpracę')}</h3>
      </div>
      <p className="body-small">
        {i18n.t(
          'Dziękujemy za akceptację. To dla nas sygnał, by przejść do kolejnego etapu. Nasz zespół skontaktuje się z Tobą, by uzyskać dane potrzebne do przygotowania umowy. W razie pytań zapraszamy do kontaktu.'
        )}
      </p>
      <Button asChild className="mr-auto">
        <a href={`tel:${isHouseHold ? HELPFIND_PHONE_HH : HELPFIND_PHONE}`}>
          <Phone width={18} className="shrink-0" />
          {isHouseHold ? HELPFIND_PHONE_HH : HELPFIND_PHONE}
        </a>
      </Button>
    </Paper>
  );
};

export default AcceptOfferCard;
